import "./CaseStudies.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import CaseStudyGallery from "./sections/CaseStudyGallery";
import Footer from "@/reusable_sections/Footer";
export default function CaseStudiesPage() {
  return <div>
      <Header />
      <Hero />
      <CaseStudyGallery />
      <Footer />
    </div>;
}